import React from "react";
import SearchTable from "../../components/SearchTable/SearchTable";
import DateFilter from "../../components/DateFilter/DateFilter";
import MultiBookingTable from "../../components/Table/Table";
import { Provider } from "react-redux";
import store from "../../redux/store/store";
import ErrorManager from "../../components/ErrorManager/ErrorManager";

function Intermodal() {
  return (
    <Provider store={store}>
      <div className="pageContentContainer">
        <ErrorManager />
        <DateFilter />
        <SearchTable />
        <MultiBookingTable />
      </div>
      {/* <EnvInfo /> */}
    </Provider>
  );
}

export default Intermodal;
